import { IntlProvider } from "react-intl";
import { connect } from "react-redux";
/*
 * As I (ft@) understand things, this module takes parameters from our state.intl,
 * and provide it to the real IntlProvider from react-intl.
 *
 */
function defaultSelector(state) {
    return Object.assign({ key: state.intl.locale }, state.intl);
}
const mapStateToProps = (state, { intlSelector = defaultSelector }) => intlSelector(state);
export default connect(mapStateToProps)(IntlProvider);
